module.exports = __webpack_public_path__ + "img/1328.9334aabf.png";